export default {"src":"/_next/static/media/stressMotivation.416a1995.svg","height":587,"width":1048,"blurWidth":0,"blurHeight":0};